(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[908],{

/***/ 71794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/offshore/make-payment/index.js + 2 modules
var make_payment = __webpack_require__(21028);
;// CONCATENATED MODULE: ./pages/vn/make-payment/data.json
var data_namespaceObject = JSON.parse('{"breadcrumbs":[{"uri":"/","title":"Home"},{"title":"Online payment for services"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/vn/make-payment/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "vn",
      page: data === null || data === void 0 ? void 0 : data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(make_payment/* default */.Z, {
        dataJson: data_namespaceObject,
        location: "vn"
      })
    })
  });
}

/***/ }),

/***/ 10509:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/make-payment",
      function () {
        return __webpack_require__(71794);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,9973,9669,4342,4090,9738,1028,9774,2888,179], function() { return __webpack_exec__(10509); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);